// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"b1048f34","447":"84e38f37","453":"16e42fb3","967":"6f9f078e"}[chunkId] + ".chunk.js";
};